<!-- Body -->
<mat-dialog-content>
    <img (contextmenu)="onRightClick($event)" src="data:image/jpg;base64,{{image}}" style="z-index:9999999; height:300px;">
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>
